import React from "react";
import { GridProps } from "./interface";
import classes from "./grid.module.scss";
import classNames from "classnames/bind";

/**
 * @param {Object}
 * columns: the number of columns in the layout, 4-5
 * children: the components to render inside the layout
 * @returns {React.Component} The Grid layout component
 */

const Grid = ({
    columns = 5,
    isFlexible = true,
    multiToOneColMobile,
    children,
}: GridProps) => {
    const parsedNumColumns =
        typeof columns === "string" ? parseInt(columns) : columns;
    const numColumns = !isNaN(parsedNumColumns) ? parsedNumColumns : 1;
    const flexibleClass = isFlexible === false ? "" : classes.flexible;

    const cx = classNames.bind(classes);
    const gridClasses = cx({
        layoutGrid: true,
        flexible: flexibleClass,
        multiToOneColMobile: multiToOneColMobile,
    });

    return (
        <div className={classes.layoutGridOuter}>
            <div
                className={gridClasses}
                style={{ "--numColumns": numColumns } as React.CSSProperties}
                data-testid={"grid"}
                data-cy="cwq-card-grid"
            >
                {children}
            </div>
        </div>
    );
};

export default Grid;
